'use strict';

angular.module('login').directive('msLearnMoreModal', [function () {
  return {
    templateUrl: 'onboarding/templates/learnMoreModal.html',
    replace: true,
    restrict: 'AE'
  };
}]);